<form [formGroup]="certificationInfoForm">
  <div class="flex flex-col md:flex-row gap-4">
    <!-- First mat-card -->
    <mat-card class="md:w-1/2 w-full">
      <mat-card-content>
        <div class="flex flex-col gap-4">
          <!-- Education Selection -->
          <div *ngIf="!license.isRenewal" class="flex flex-col">
            <label class="text-lg font-semibold">Education</label>

            <div class="flex flex-col gap-4">
              <span class="font-semibold">International Credential Evaluation</span>
              <span>Below is a list of credential evaluation agencies approved by OHA
                    for internationally educated health care professionals.
                    Evaluations accepted by OHA must be an original report that establishes
                    educational equivalency for initial certification in the United States.</span>
              <div class="flex flex-row gap-4 pl-4">
                <span>*</span>
                <a href="https://www.cgfns.org/" target="_blank">TruMerit</a>
              </div>
              <div class="flex flex-row gap-4 pl-4">
                <span>*</span>
                <span><strong>Qualifying Report Type: </strong>OHA accepts a Credentials Evaluation Service (CES) Professional Report ® prepared
                by TruMerit as a qualifying evaluation of international education.
                All other reports offered do not meet the requirement for hemodialysis certification and are not accepted by OHA.</span>
              </div>
              <div class="flex flex-row gap-4 pl-4">
                <span>*</span>
                <a href="https://eres.com/" target="_blank">Educational Records Evaluation Service (ERES)</a>
              </div>
              <div class="flex flex-row gap-4 pl-4">
                <span>*</span>
                <a href="https://jsilny.org/" target="_blank">Josef Silny & Associates, Inc., International Education Consultants</a>
              </div>
            </div>

            <div class="flex flex-col" *ngIf="!isFullCertification()">
              <span class="text-lg font-semibold">Documentation stating that you have completed your hemodialysis training is required.</span>
              <span class="text-lg">This may be a certificate, skills checklist, or a letter from your manager.
                An extended training program should consist of a minimum of 80 hours of classroom study and 160 hours of supervised clinical experience.</span>
            </div>

            <div class="pt-4">
              <p>
                Please check one below - Documentation of completion required
              </p>
            </div>

            <mat-form-field appearance="fill">
              <input matInput formControlName="education" style="display: none;">
              <mat-radio-group formControlName="education" class="flex flex-col gap-2">
                <mat-radio-button value="High School">High School</mat-radio-button>
                <mat-radio-button value="GED">GED</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="certificationInfoForm.get('education')?.invalid">
                Education is required.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- National Certification (Only for Full Initial Certification) -->
          <div *ngIf="isFullCertification()">
            <label class="text-lg font-semibold">National Examination/Certification</label>

            <div class="py-4">
              <p>
                Please check one of the following boxes and indicate the date the test was passed.
              </p>
            </div>

            <mat-form-field appearance="fill" class="w-full">
              <input matInput formControlName="nationalCertification" style="display: none;">
              <mat-radio-group formControlName="nationalCertification" class="flex flex-col gap-2">
                <mat-radio-button value="BONENT">BONENT</mat-radio-button>
                <mat-radio-button value="NNCC_CCHT">NNCC/CCHT</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="certificationInfoForm.get('nationalCertification')?.invalid">
                Certification is required.
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <div class="flex flex-col gap-4 md:w-1/2 w-full md:ml-auto">

      <div class="flex flex-col" *ngIf="license.isRenewal && license.full">
        <span class="text-lg text-amber-400" *ngIf="daysLate > 90 && daysLate < 365">
          Your license has been expired for more than 90 days.
          You are required to submit a national certification, work hours, continuing education, and an abbreviated training program.
        </span>
        <span class="text-lg text-amber-400" *ngIf="daysLate <= 90">
          For a renewal you are required to submit work hours and continuing education documentation, or a national certification.
        </span>
      </div>

      <mat-card>
        <mat-card-content>
          <document [entityId]="license.licenseMasterId"
                    [entityType]="sharedService.entityTypeLicense"
                    [statuses]="license.statuses"
                    [types]="certificationDocumentTypes"></document>
        </mat-card-content>
      </mat-card>
      <div class="flex flex-col" *ngIf="documentErrors.length > 0">
        <span class="text-xl portal-error">Missing the Following Documents:</span>
        <span class="text-lg portal-error" *ngFor="let error of documentErrors">{{ error }}</span>
      </div>
    </div>
  </div>
</form>
